import _extends from "@babel/runtime/helpers/extends";
import { Button as WDSButton, Tooltip } from '@wix/design-system';
import classNames from 'classnames';
import React from 'react';
import s from './StudioCta.scss';
export const StudioCta = _ref => {
  let {
    filled,
    size = 'small',
    onClick,
    children,
    light,
    disabled,
    disabledTooltipContent,
    onShowTooltip,
    ...props
  } = _ref;
  const shouldShowTooltip = disabled && disabledTooltipContent;
  return /*#__PURE__*/React.createElement(Tooltip, {
    disabled: !shouldShowTooltip,
    placement: "bottom",
    content: disabledTooltipContent,
    className: s.studioCtaTooltip,
    onShow: onShowTooltip
  }, /*#__PURE__*/React.createElement(WDSButton, _extends({
    skin: light ? 'light' : 'standard',
    className: classNames(s.studioCta, {
      [s.filled]: filled,
      [s.light]: light,
      [s.disabled]: disabled
    }),
    onClick: onClick,
    size: size,
    fullWidth: true,
    disabled: disabled
  }, props), children));
};
//# sourceMappingURL=StudioCta.js.map